import SignaturePad from 'signature_pad'

export default {
  init() {
    // JavaScript to be fired on the home page


  }, finalize() {


    $(document).ready(function () {


      const formIdValue = $('#tfa_dbFormId').val();


      if ($('#signatureCanvas').length > 0 && $('.wForm input[title="PDF file"]').length > 0) {


        const canvas = document.querySelector('#signatureCanvas');
        let signaturePad = new SignaturePad(canvas);

        // Clear the Signaturepad
        $('#signatureCanvas + button').click(function (e) {
          e.preventDefault();
          signaturePad.clear();
        });

// Example usage:
        waitForInitialization(function () {
            if (typeof wFORMS !== 'undefined') {
              if (wFORMS.behaviors && wFORMS.behaviors.validation) {
                let formValidation = false;

                $('.wForm form').submit(function (event) {
                  // check validation
                  if (formValidation) {
                    event.preventDefault();
                    //Generate PDF and attach to hidden field


                    if (formIdValue === '4873186') {
                      generate_GS_PDF(signaturePad,function () {
                        //Resume form submission
                        $('.wForm form').off('submit').submit();
                      })
                    }

                    // add additional forms via if ID==XX { callback_function() }
                    // else {
                        // replace with pdf specific template
                      // generate_GS_PDF(function () {
                        //Resume form submission
                        // $('.wForm form').off('submit').submit();
                      // })
                    // }


                  }
                });


                // on formassembly validation set formValidation to true
                wFORMS.behaviors.validation.onPass = function () {
                  formValidation = true;
                };


              } else {

                console.log('wFORMS or wFORMS.behaviors.validation does not exist');
              }
            }
          }
        );

      }

      function attachPdfToUploadField(pdfData, pdfName, callback) {


        // Convert the decoded data to a Blob
        var byteArray = new Uint8Array(pdfData.length);
        for (var i = 0; i < pdfData.length; i++) {
          byteArray[i] = pdfData.charCodeAt(i);
        }
        var blob = new Blob([byteArray], {type: 'application/pdf'});

        // Create a URL for the Blob and open it
        // var url = URL.createObjectURL(blob);
        // open in a new tab
        // window.open(url);


        let fileInputElement = $('.wForm input[title="PDF file"]');
        let container = new DataTransfer();

        let file = new File([blob], pdfName, {
          type: 'application/pdf', lastModified: new Date().getTime(),
        });
        container.items.add(file);
        fileInputElement[0].files = container.files;
        // fileInputElement.files = URL.createObjectURL(file);

        // download file
        // var link = document.createElement('a');
        // link.href = URL.createObjectURL(file);
        // link.download = file.name;
        // link.click();

        callback();
      }

      function generate_GS_PDF(signaturePad, callback) {

        //set form specific data

        let formData = {
          'date': $('.wForm input[title="Date"]').val(),
          'name': $('.wForm input[title="Printed Name"]').val(),
          'patient_name': $('.wForm input[title="Patient Full Name"]').val(),
          'relationship': $('.wForm select[title="Relationship to Patient"]').val(),
          'email': $('.wForm input[title="Email"]').val(),
          'phone': $('.wForm input[title="Phone"]').val(),
          'representative': $('.wForm input[title="Authorized Representative Full Name"]').val(),
          'signature': signaturePad.toDataURL('image/png', 1),
          'tfa_dbFormId': formIdValue,
        }

        let ajaxURL = window.location.origin + '/wp-admin/admin-ajax.php'

        // endpoint to custom function for GS PDF Generator, with Template and coordinates
        $.ajax({
          type: 'POST', url: ajaxURL, data: {
            action: 'generate_GS_pdf_endpoint', formData: formData,
          },
          dataType: 'json', encode: true, success: function (response) {
            if (response) {

              let pdfDataFormat = atob(response.data);
              try {


                // PDF Naming Convention set here Patient-Full-Name-patient-consent.pdf
                let prefix = $('.wForm input[title="Patient Full Name"]').val().replace(/ /g, '-');
                let gsPdfName = prefix + '-patient-consent.pdf'

                attachPdfToUploadField(pdfDataFormat, gsPdfName, function () {
                  callback();
                });

              } catch (e) {
                return 'Decoding Error:' + e;
              }
            }
          }, error: function (xhr, status, error) {
            return 'Error:' + error;
          },
        });
      }

      function waitForInitialization(callback) {
        if (wFORMS.initialized) {
          callback();
        } else {
          var checkInterval = setInterval(function () {
            if (wFORMS.initialized) {
              clearInterval(checkInterval);
              callback();
            }
          }, 100); // Check every 100 milliseconds
        }
      }

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pdfGen.js